// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"192":"order.show","304":"favourites","357":"content-ContentTypeProductList","912":"search.result"}[chunkId] + "." + {"192":"f4dbcb94","304":"02bc5654","357":"02bc5654","912":"02bc5654"}[chunkId] + ".css";
};